import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/Settings.gif'


const _withScopeId = n => (_pushScopeId("data-v-8bdc259c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "flex justify-between z-10 relative pointer-events-none"
}
const _hoisted_2 = { class: "ml-7 flex flex-col items-center w-10 pointer-events-auto" }
const _hoisted_3 = { class: "mr-7 mt-4 flex flex-col items-end" }
const _hoisted_4 = { class: "pointer-events-auto" }
const _hoisted_5 = { class: "w-13 hidden peer-focus:block" }
const _hoisted_6 = { class: "bg-white border mt-2" }
const _hoisted_7 = ["onMousedown"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_9 = { class: "flex flex-col mt-32 pointer-events-auto" }
const _hoisted_10 = { class: "flex flex-row-reverse" }
const _hoisted_11 = {
  key: 0,
  class: "h-80 overflow-scroll bg-red-400 text-xs px-5"
}
const _hoisted_12 = { class: "hidden group-hover:block ml-4" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = {
  key: 0,
  class: "text-xs bg-green-400"
}
const _hoisted_15 = {
  key: 1,
  class: "text-xs bg-red-700"
}
const _hoisted_16 = { class: "mt-7 flex flex-row-reverse" }
const _hoisted_17 = { class: "ml-1" }
const _hoisted_18 = {
  key: 0,
  class: "flex"
}
const _hoisted_19 = { class: "ml-3" }
const _hoisted_20 = { class: "mt-7 flex flex-row-reverse" }
const _hoisted_21 = { class: "ml-1" }
const _hoisted_22 = {
  key: 0,
  class: "flex flex-col bg-gray-500"
}
const _hoisted_23 = { class: "p-2 flex justify-between" }
const _hoisted_24 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_25 = { class: "flex flex-col m-2" }
const _hoisted_26 = {
  key: 1,
  class: "flex flex-col"
}
const _hoisted_27 = { class: "m-2" }
const _hoisted_28 = { class: "flex" }
const _hoisted_29 = ["src", "onClick"]
const _hoisted_30 = {
  key: 2,
  class: "fixed top-0 left-0 w-full h-screen bg-black z-20"
}
const _hoisted_31 = {
  key: 3,
  class: "absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-50"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-white" }, "Processing the export....", -1))
const _hoisted_34 = [
  _hoisted_32,
  _hoisted_33
]
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "map",
  class: "top-0 absolute bottom-0 w-full"
}, null, -1))

import { onMounted, reactive, watch, watchEffect } from '@vue/runtime-core';
import { computed, ref } from "vue"
import mapboxgl,{ LngLatLike, Map, AnyLayer, Layer, Marker } from 'mapbox-gl';
import html2canvas from 'html2canvas';

type LayerState = {
    [index : Layer["id"]]: true | false
}

export default /*#__PURE__*/_defineComponent({
  emits: ["exitMap"],
  setup(__props, { emit }: { emit: ({
  (e: 'exitMap'): void
}), expose: any, slots: any, attrs: any }) {



const loading = ref(false);
let map : Map;
const layers =  ref<Layer[]>();
const showTools = ref<'layers'| 'size' | 'addText'| 'addIcon' | null>(null)
const mapSize = reactive({
    width: 0,
    height: 0
});
const textToAdd = reactive({
    text: '',
    size: 12,
    color: 'green'
});

// Watch the width change
watch(
  () => mapSize.width,
  (newValue, oldValue) => {
    if(isNaN(newValue)){
        alert("please pass width in pixel")
        mapSize.width = oldValue
    }
    if(newValue > window.screen.width){
        alert("The set pixel is above you screen width")
        mapSize.width = oldValue
    }
  }
)
watch(
  () => mapSize.height,
  (newValue, oldValue) => {
    if(isNaN(newValue)){
        alert("please pass height in pixel")
        mapSize.height = oldValue
    }
    if(newValue > window.screen.height){
        alert("The set pixel is above you screen width")
        mapSize.height = oldValue
    }
  }
)

mapboxgl.accessToken = process.env.VUE_APP_MAPBOX_TOKEN;


const sortedLayers = computed(() => {
  let sortedStyles: Record<string, Layer[]> = {}
        if(layers.value){
            for(let mapStyle of layers.value){
                if(!mapStyle['source-layer']){
                    sortedStyles['general'] ? sortedStyles['general'].push(mapStyle): sortedStyles['general'] = [mapStyle]
                    continue
                    /* for(const key in Object.keys(sortedStyles)){
                        console.log(key)
                        let regex = new RegExp(mapStyle.id,'g')
                        if(key.match(regex)){
                            if(!sortedStyles[key]){
                                sortedStyles[key] = [mapStyle];
                                break;
                            }
                            sortedStyles[key].push(mapStyle);
                            break;
                        }
                    } */
                }
                if(!sortedStyles[mapStyle['source-layer']]){
                    sortedStyles[mapStyle['source-layer']] = [mapStyle]
                    continue
                }
                sortedStyles[mapStyle['source-layer']].push(mapStyle)
            }
        }
        return sortedStyles;
})

let layerState:LayerState = reactive({}) ;

onMounted(()=>{
    map = new mapboxgl.Map({
        container: 'map',
        style: 'mapbox://styles/mapbox/streets-v11', 
        center: [-74.5, 40],
        zoom: 9,
        preserveDrawingBuffer: true
    }); 
    map.on('load', ()=>{
        const mapLayers: any = map.getStyle().layers
        // Set layer state
        for(let layers of mapLayers){
            layerState[layers.id] = false;
        }
        layers.value = mapLayers;
    })
})

function zoomIn(){
    map.zoomIn();
}
function zoomOut(){
    map.zoomOut();
}

// search for a particular location
let timeOut: number|null = null;
const searchQuery = ref('');
let searchResult = reactive({
    data:{}
});
watchEffect(() => {
    if(searchQuery.value !== ""){
        if(timeOut !== null){
            return;
        }
       timeOut = setTimeout(()=>{
            console.log(searchQuery.value)
            searchLocation(searchQuery.value)
            timeOut = null
       },400)
    }
})
async function searchLocation(q: string){
    let url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${q}.json?access_token=${process.env.VUE_APP_MAPBOX_TOKEN}`;
    const response = await fetch(url);
    searchResult.data = await response.json();
    console.log(searchResult.data)
}
function goToMap(location: LngLatLike){
    map.flyTo({
        center: location
    })
}

function toggleLayer(layer: Layer['id']){
    const currentState = layerState[layer]
    // if currentState = false then it is visible
    const setAs = currentState ? 'visible' : 'none'
    map.setLayoutProperty(layer,'visibility',setAs)
    layerState[layer] = !currentState
}

function setSize(type: 'width' | 'height', value: number){
    console.log(window.screen)
    if(!isNaN(value)){
        alert("please pass " + type + " in pixel")
        return
    }
    if(type === 'width'){
        if(value> window.screenX){
            alert("The set pixel is above you screen width")
            return
        }
    }
    if(type === 'height'){
        if(value> window.screenY){
            alert("The set pixel is above you screen height")
            return
        }
    }
    mapSize[type] = value
}

//Add ICON and TEXT
const icons: { [key: string]: any } = {
    "profileSvg": require("./../assets/icons/basic-profile-ui-svgrepo-com.svg"),
    "touchSvg": require("../assets/icons/basic-touch-ui-svgrepo-com.svg"),
    "homeSvg": require("../assets/icons/basic-home-svgrepo-com.svg")
}
function addText(){
    if(textToAdd.text !== ""){
        let text = document.createElement('span')
        text.innerHTML = `<span class="text-[${textToAdd.size}px]" style="color:${textToAdd.color}; font-size:${textToAdd.size}px">${textToAdd.text}</span>`
        const deleteButton = document.createElement('div')
        deleteButton.innerHTML = `<button class="bg-red-400 font-medium rounded-md">Delete</button>`
        const {lng, lat} = map.getCenter();
        const marker = new mapboxgl.Marker({
                            element: text,
                            draggable: true
                        });
        deleteButton.addEventListener('click',(e)=>{
            marker.remove()
            setTimeout(() => {
                alert('Deleted successfully')
            }, 300);
        })
        marker.setPopup(new mapboxgl.Popup().setDOMContent(deleteButton))
            .setLngLat([lng, lat])
            .addTo(map);

        textToAdd.text = '';
        showTools.value = null;
        setTimeout(() => {
            alert("You can drag the element to the preferred location | To delete text click")
        }, 300);
    }
}
function addIcon(key: string){
    let marker: Marker;
    if(key === 'default'){
         marker = new mapboxgl.Marker({
                        draggable: true
                    })
    }else{
        let icon = document.createElement('div')
        icon.innerHTML = `<img src="${icons[key]}" class="w-9 h-9"/>`
        marker = new mapboxgl.Marker({
                        element: icon,
                        draggable: true
                    })
    }
    const {lng, lat} = map.getCenter();

    //set delete button
    const deleteButton = document.createElement('div')
    deleteButton.innerHTML = `<button class="bg-red-400 font-medium rounded-md">Delete</button>`
    deleteButton.addEventListener('click',(e)=>{
        marker.remove()
        setTimeout(() => {
            alert('Deleted successfully')
        }, 300);
    })
    // add to map
    marker.setPopup(new mapboxgl.Popup().setDOMContent(deleteButton))
            .setLngLat([lng, lat])
            .addTo(map);

    showTools.value = null
    setTimeout(() => {
        alert("You can drag the element to the preferred location | To delete icon click")
    }, 300);
}
function exportCanvasAsPNG(canvasElement: any, fileName: string) {
    const MIME_TYPE = "image/png";

    const imgURL = canvasElement.toDataURL(MIME_TYPE);

    const dlLink = document.createElement('a');
    dlLink.download = fileName;
    dlLink.href = imgURL;
    dlLink.dataset.downloadurl = [MIME_TYPE, dlLink.download, dlLink.href].join(':');

    document.body.appendChild(dlLink);
    dlLink.click();
    document.body.removeChild(dlLink);
}
function exportMap(){
    if(mapSize.width === 0 || mapSize.height === 0){
        alert('please set the map export size')
        showTools.value = 'size'
        return;
    }
    let container = map.getContainer();
    let formerwidth  = window.screen.availWidth;
    let formerheight = window.screen.availHeight;

    container.style.height = `${mapSize.height}px`
    container.style.width = `${mapSize.width}px`

    let center = map.getCenter();
    loading.value = true
    map.resize()

    map.once('idle',()=>{
        html2canvas(container).then((element)=>{
            exportCanvasAsPNG(element, 'newMap')
            container.style.height = `${formerheight}px`;
            container.style.width = `${formerwidth}px`;
            map.resize()
            map.setCenter(center);
        }).finally(()=> {
            setTimeout(()=>{
                loading.value = false
            },1000)
        })
    })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                class: "border-2 border-gray-600 py-1 px-3 mt-7 hover:bg-red-300 bg-slate-300",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('exitMap')))
              }, "Exit")
            ]),
            _createElementVNode("div", { class: "flex flex-col mt-40" }, [
              _createElementVNode("button", {
                class: "border-2 border-gray-600 py-1 px-3 hover:bg-red-300 bg-slate-300",
                onClick: zoomIn
              }, "+"),
              _createElementVNode("button", {
                class: "border-2 border-gray-600 py-1 px-3 mt-5 hover:bg-red-300 bg-slate-300",
                onClick: zoomOut
              }, "-")
            ])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "border-red-400 border-2 focus:outline-none py-1 px-1 focus:px-3 w-14 text-xs rounded focus:w-full focus:text-base peer",
                placeholder: "Search ...",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchQuery).value = $event))
              }, null, 512), [
                [_vModelText, searchQuery.value]
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("ul", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(searchResult).data.features, (result) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: result.id,
                        class: "hover:bg-gray-400 p-2 cursor-pointer",
                        onMousedown: _withModifiers(($event: any) => (goToMap(result.center)), ["prevent"])
                      }, _toDisplayString(result.place_name), 41, _hoisted_7))
                    }), 128))
                  ])
                ]),
                _hoisted_8
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", null, [
                  _createElementVNode("button", {
                    class: "border-2 border-gray-600 py-1 px-2 hover:bg-red-300 bg-slate-300 text-xs",
                    onClick: _cache[2] || (_cache[2] = ()=>showTools.value === 'layers' ? showTools.value = null : showTools.value = 'layers')
                  }, "Layers")
                ]),
                (showTools.value === 'layers')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createElementVNode("ul", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sortedLayers), (layerTypes, type) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: type,
                            class: "group hover:font-medium hover:text-sm"
                          }, [
                            _createTextVNode(_toDisplayString(type) + " ", 1),
                            _createElementVNode("ul", _hoisted_12, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(layerTypes, (layer) => {
                                return (_openBlock(), _createElementBlock("li", {
                                  key: layer.id,
                                  class: "hover:font-bold cursor-pointer",
                                  onClick: ($event: any) => (toggleLayer(layer.id))
                                }, [
                                  _createTextVNode(" - " + _toDisplayString(layer.id) + " | ", 1),
                                  (_unref(layerState)[layer.id])
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_14, "show"))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_15, "hide"))
                                ], 8, _hoisted_13))
                              }), 128))
                            ])
                          ]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("button", {
                    class: "border-2 border-gray-600 py-1 px-2 hover:bg-red-300 bg-slate-300 text-xs",
                    onClick: _cache[3] || (_cache[3] = ()=>showTools.value === 'size' ? showTools.value = null : showTools.value = 'size')
                  }, "Resize")
                ]),
                (showTools.value === 'size')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _createElementVNode("div", null, [
                        _withDirectives(_createElementVNode("input", {
                          type: "number",
                          placeholder: "width",
                          class: "w-16",
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(mapSize).width) = $event))
                        }, null, 512), [
                          [_vModelText, _unref(mapSize).width]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        _withDirectives(_createElementVNode("input", {
                          type: "number",
                          placeholder: "height",
                          class: "w-16",
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(mapSize).height) = $event))
                        }, null, 512), [
                          [_vModelText, _unref(mapSize).height]
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("button", {
                    class: "border-2 border-gray-600 py-1 px-2 hover:bg-red-300 bg-slate-300 text-xs",
                    onClick: _cache[6] || (_cache[6] = ()=>showTools.value === 'addText' | 'addIcon' ? showTools.value = null : showTools.value = 'addText')
                  }, "Add")
                ]),
                ((showTools.value === 'addText' || showTools.value === 'addIcon'))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("span", {
                          onClick: _cache[7] || (_cache[7] = ()=>showTools.value === 'addText' ? '' : showTools.value = 'addText'),
                          class: "bg-black text-white tex-xs p-1 cursor-pointer"
                        }, "Text"),
                        _createElementVNode("span", {
                          onClick: _cache[8] || (_cache[8] = ()=>showTools.value === 'addIcon' ? '' : showTools.value = 'addIcon'),
                          class: "bg-black text-white tex-xs p-1 cursor-pointer"
                        }, "Icon")
                      ]),
                      (showTools.value === 'addText')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                            _createElementVNode("div", _hoisted_25, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                placeholder: "text",
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(textToAdd).text) = $event)),
                                class: "border border-red-400"
                              }, null, 512), [
                                [_vModelText, _unref(textToAdd).text]
                              ]),
                              _withDirectives(_createElementVNode("input", {
                                type: "number",
                                placeholder: "size in px",
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(textToAdd).size) = $event)),
                                class: "border border-red-400 my-2"
                              }, null, 512), [
                                [_vModelText, _unref(textToAdd).size]
                              ]),
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                placeholder: "color",
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(textToAdd).color) = $event)),
                                class: "border border-red-400"
                              }, null, 512), [
                                [_vModelText, _unref(textToAdd).color]
                              ]),
                              _createElementVNode("div", { class: "mt-2" }, [
                                _createElementVNode("button", {
                                  onClick: addText,
                                  class: "border-2 border-gray-600 py-1 px-2 hover:bg-red-300 bg-slate-300 text-xs"
                                }, "Add")
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (showTools.value === 'addIcon')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                            _createElementVNode("div", _hoisted_27, [
                              _createElementVNode("div", _hoisted_28, [
                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(icons, (icon, key) => {
                                  return _createElementVNode("div", {
                                    key: key,
                                    class: "h-9 w-9"
                                  }, [
                                    _createElementVNode("img", {
                                      src: icon,
                                      onClick: ($event: any) => (addIcon(key))
                                    }, null, 8, _hoisted_29)
                                  ])
                                }), 64))
                              ]),
                              _createElementVNode("div", {
                                class: "bg-black text-white tex-xs p-1 cursor-pointer",
                                onClick: _cache[12] || (_cache[12] = ($event: any) => (addIcon('default')))
                              }, "Default")
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", { class: "mt-20 self-end" }, [
                _createElementVNode("div", null, [
                  _createElementVNode("button", {
                    class: "border-2 border-gray-600 py-1 px-2 hover:bg-red-300 bg-slate-300 text-xs",
                    onClick: exportMap
                  }, "Export")
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    ((_unref(mapSize).width && !loading.value))
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "absolute z-10 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 border border-gray-600 pointer-events-none",
          style: _normalizeStyle({'width': `${_unref(mapSize).width}px`, 'height': `${_unref(mapSize).height}px`})
        }, null, 4))
      : _createCommentVNode("", true),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_30))
      : _createCommentVNode("", true),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_31, _hoisted_34))
      : _createCommentVNode("", true),
    _hoisted_35
  ], 64))
}
}

})